export { mapToInboxItem, mapToInboxMessage } from './mapToInboxItem'
export type { InboxMessage } from './type'
